<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="show-topup-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalTopup"
    ></button>
    <div
      class="modal fade"
      id="modalTopup"
      tabindex="-1"
      aria-labelledby="modalTopupLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title justify-content-center">Top Up</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Mobile <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <span style="font-size: 18px;">{{ form.phone_number }}</span>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Branch <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <Multiselect v-model="form.branch_id" :options="branchs" :canClear="false" />
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Staff <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <Multiselect v-model="form.employee_name" :options="staffs" :canClear="false" :searchable="true"/>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Top Up Name <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <Multiselect v-model="form.topup_id" :options="topUps" @change="changeTopUp" placeholder="Amount" label="topup_name" :canClear="false" />
              </div>
            </div>
            <div class="row mb-3 align-items-center" v-if="form.payment_amount">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">{{ $t('Payment_Amount_Topup') }} <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                $ {{ form.payment_amount }}
              </div>
            </div>
            <div class="row mb-3 align-items-center" v-if="form.bonus_amount">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Bonus Amount</label>
              </div>
              <div class="col-7 ps-0">
                $ {{ form.bonus_amount }}
              </div>
            </div>
            <div class="row mb-8 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Top Up Method <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <Multiselect v-model="form.payment_method" :options="paymentMethods" :canClear="false" placeholder="Payment method" />
              </div>
            </div>
            <div class="text-center">
              <button class="btn btn-primary" @click="handleConfirm" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import TestService from "../../../services/test.service";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";

export default {
  name: "TopupModal",
  components: {
    MaterialSnackbar,
    Multiselect,
    MaterialLoading
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    idSelected: {
      type: Number,
      default: 0,
    },
    member: {
      type: Object,
      required: true,
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.initializeData();
      }
    }
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      loading: false,
      branch: '',
      staff: '',
      topup_id: '',
      topupMethod: '',
      branchs: [],
      staffs: [],
      paymentMethods: [],
      topUps: [],
      form: {
        phone_number: this.member.phone_number,
        branch_id: 0,
        employee_name: 0,
        payment_method: 0,
        topup_id: 0,
        payment_amount: 0,
        bonus_amount: 0,
        pos_id: "1"
      }
    };
  },
  methods: {
    async initializeData() {
      // Reset form data
      this.form = {
        phone_number: this.member.phone_number,
        branch_id: 0,
        employee_name: 0,
        payment_method: 0,
        topup_id: 0,
        payment_amount: 0,
        bonus_amount: 0,
        pos_id: "1"
      };
      this.loading = false;
      this.message = "";
      this.snackbar = null;

      // Load fresh data
      await Promise.all([
        this.getBranches(),
        this.getPaymentMethods(),
        this.getTopUps(),
        this.getStaffs()
      ]);

      // Set default values after data is loaded
      this.form.branch_id = this.branchs[0]?.value || 0;
      this.form.employee_name = this.staffs[0]?.value || 0;
    },
    changeTopUp(topUpId) {
      this.topUps.forEach((item) => {
        if(item.id == topUpId) {
          this.form.top_up_amount = new Intl.NumberFormat("en", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }).format(parseFloat(item.topup_amount ? item.topup_amount : 0))
          this.form.payment_amount = new Intl.NumberFormat("en", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }).format(parseFloat(item.payment_amount ? item.payment_amount : 0))
          this.form.bonus_amount = new Intl.NumberFormat("en", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }).format(parseFloat(item.bonus_amount ? item.bonus_amount : 0))
        }
      })
    },

    getTopUps() {
      this.isLoadData = false;
      this.topUps = []
      TestService.getDataTopUp().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.topUps = response.data.data;
            this.isLoadData = true;
          } else {
            this.message = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error;
          this.hideLoader();
        }
      );
    },

    getBranches() {
      this.isLoadData = false;
      TestService.getBranches().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branchs = response.data.data;
            this.form.branch_id = this.branchs[0] ? this.branchs[0].value : 0
            this.isLoadData = true;
          } else {
            this.message = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error;
          this.hideLoader();
        }
      );
    },

    getPaymentMethods() {
      this.isLoadData = false;
      TestService.getPaymentMethods().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.paymentMethods = response.data.data;
            this.isLoadData = true;
          } else {
            this.message = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error;
          this.hideLoader();
        }
      );
    },

    getStaffs() {
      this.isLoadData = false;
      TestService.getStaffs().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.staffs = response.data.data;
            this.form.employee_name = this.staffs[0] ? this.staffs[0].value : 0
            this.isLoadData = true;
          } else {
            this.message = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error;
          this.hideLoader();
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    validateForm() {
      const requiredFields = [
        { field: 'phone_number', message: 'Phone Number is required' },
        { field: 'branch_id', message: 'Branch is required' },
        { field: 'employee_name', message: 'Staff is required' },
        { field: 'topup_id', message: 'Top Up Name is required' },
        { field: 'payment_method', message: 'Top Up Method is required', condition: value => !value || value == 0 },
        { field: 'payment_amount', message: 'Payment Amount is required' }
      ];

      for (const item of requiredFields) {
        const value = this.form[item.field];
        if (item.condition ? item.condition(value) : !value) {
          this.message = item.message;
          this.snackbar = "danger";
          this.setTimeOutNotification();
          return false;
        }
      }
      return true;
    },

    async handleConfirm() {
      this.loading = true;
      if (!this.validateForm()) {
        this.loading = false;
        return;
      }
      await TestService.addTopupAmount(this.form).then(
        (response) => {
          if (response.data.result.isSuccess) {
            // Emit event to notify parent component to refresh topup history
            this.$emit('topup-success');
            this.snackbar = "success";
            this.message = "Top Up Successful";
            this.loading = false;
            $('.btn-close-modal').click();
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.message = error.response.data.result.message;
          this.snackbar = "danger";
          this.setTimeOutNotification();
        }
      );
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 99999;
}

.modal-dialog {
  max-width: 75vw;
  max-width: 750px !important;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.table-responsive::-webkit-scrollbar {
  height: 7px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.option-btn {
  background: #2677D9 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 4px !important;
  font-size: 16px !important;
  transition: background 0.2s, color 0.2s !important;

}
.option-btn.active {
  background: #fff;
  color: #2677D9;
  border: 2px solid #2677D9;
  font-weight: bold;
}

.label-bold {
  font-weight: 600;
  font-size: 16px;
  color: #344767;
  margin-bottom: 0 !important;
}
.text-danger {
  color: #e74c3c !important;
}
.form-select, .form-control {
  font-size: 16px;
  border-radius: 6px;
  min-height: 40px;
}
.btn-primary {
  background: #2677D9  !important;
  border: none !important;
  font-weight: bold;
  color: #fff !important;
}
.btn-primary:active, .btn-primary:focus {
  background: #2d2d7f;
  border-color: #2d2d7f;
}

.modal-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
}

.modal-title {
  flex: 1;
  text-align: center;
  margin: 0;
}

.btn-close-modal {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: #888;
  background: none;
  border: none;
}
</style>

